import request from "@/utils/request";
import { fileService } from "@/api/common/file-utils";

export default {
  findFacilityListPage: (param) => {
    return request({
      url: `/qspiFacilityMonthOutbound/findListPage`,
      method: "post",
      data: param,
    });
  },
  findListPage: (param) => {
    return request({
      url: `/qspiDcInbound/findListPage`,
      method: "post",
      data: param,
    });
  },
  exportList: (param) => {
    return request({
      url: `/qspiDcInbound/dataListDownload`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    }).then((resp)=>{
      fileService.respToFile(resp, 'DC月度收获量.xlsx');
    });
  },
  gcQuery: (param) => {
    return request({
      url: `/qspiGc`,
      method: "get",
      params:param
    });
  },
  gcUpdate: (param) => {
    return request({
      url: `/qspiGc`,
      method: "post",
      data: param,
    });
  },
  gcDelete: (ids) => {
    return request({
      url: `/qspiGc/?ids=${ids}`,
      method: "delete",
    });
  },

};
